// extracted by mini-css-extract-plugin
module.exports = {"image-copyright":"Copyright_image-copyright__bXee_","top":"Copyright_top__ynSab"};